module.exports = __webpack_public_path__ + "static/media/storyLikeEmpty.ec3d5ea1.svg";